import { metaDataFormDefaultsFor } from './../components/editor/metadataFormFields.js'

export function validateScene(tag, scene) {
  console.log("validateScene", tag, scene)
  let df = metaDataFormDefaultsFor(tag.template)
  let check = {
    valid: true,
    msg: ''
  }
  if (!scene) {
    // if no scene is selected, fall back to first scene
    scene = tag.scenes[0]
  }
  if (!scene.waypoints || scene.waypoints.length < df.waypoints) {
      check.valid = false
      check.msg = `A ${df.label} scene needs at least ${df.waypoints} waypoints.\n`
  }

  const validateTagContentMsg = validateTagContent(tag)
  if (validateTagContentMsg !== '') {
    check.msg += `${validateTagContentMsg}\n`
    check.valid = false
  }

  const validateTagBehaviourMsg = validateTagBehaviour(tag)
  if (validateTagBehaviourMsg !== '') {
    check.msg += `${validateTagBehaviourMsg}\n`
    check.valid = false
  }
  
  return check
}

function validateTagContent(tag) {
  switch (tag.template.toLowerCase()) {
    case "textbox":
      return validateTextbox(tag.meta)
    case "ptag":
      return validatePtag(tag.meta)
    case "generic":
      return validateGeneric(tag.meta)
    case "buttontag":
      return validateButtonTag(tag.meta)
    case "hotspot":
      return validateHotspotTag(tag.meta)
    case "imagetag":
      return validateImageTag(tag.meta)
    case "quiz":
      return validateQuiz(tag.meta)
    case "quizzes":
        return validateQuizzes(tag.meta)
    case "singlechoice":
      return validateSingleChoice(tag.meta)
    case "filter":
      return !tag.meta.filter || tag.meta.filter === '' ? 'The filter tag needs a selected filter.' : ''
    case "cover":
      return validateCover(tag.meta)
  }
  return ""
}

function validateTagBehaviour(tag) {
  if (tag.meta.behaviour && tag.meta.behaviour.action) {
    switch (tag.meta.behaviour.action.toLowerCase()) {
     case "jumpto":
       return !tag.meta.behaviour.value ? 'The jump to behaviour needs a value' : ''
      case "sleep":
        return !tag.meta.behaviour.value ? 'The sleep behaviour needs a value in milliseconds' : ''
      case "open":
        return validateOpenBehaviour(tag.meta.behaviour)
      case "open-asset":
        return validateOpenAssetBehaviour(tag.meta.behaviour)
    }
  }
  return ""
}

function validateTextbox(meta) {
  if (!meta.value || !meta.value.markdown || meta.value.markdown[meta.value.markdown.lang] === '') {
    return 'The textbox needs at least a text.'
  }
  return ''
}

function validatePtag(meta) {
  if (meta.title[meta.title.lang] === '' && meta.text[meta.text.lang] === '' && meta.eyecatcher[meta.eyecatcher.lang] === '') {
    return 'The bubble needs at least a title or a description or a eyecatcher.'
  }
  return ''
}

function validateGeneric(meta) {
  if (meta.title[meta.title.lang] === '' && meta.text[meta.text.lang] === '' && meta.linkLabel[meta.linkLabel.lang] === '') {
    return 'The annotation needs at least a title or a description or a linkLabel.'
  }
  return ''
}

function validateButtonTag(meta) {
  if (meta.text[meta.text.lang] === '') {
    return 'The button needs at least a text.'
  }
  return ''
}

function validateHotspotTag(meta) {
  if (!meta.shape) {
    return 'The hotspot needs at least a shape.'
  }
  return ''
}

function validateImageTag(meta) {
  if (!meta.imageSrc || meta.imageSrc === '') {
    return 'The image tag needs at least a image.'
  }
  return ''
}

function validateQuizzes(meta) {
  if (meta.quizzes.length === 0) {
    return 'The multi quizzes needs at least one quiz'
  } else {
    let validationMessage = ''
    meta.quizzes.map((quiz) => {
      validationMessage += validateQuiz(quiz)
    })
    return validationMessage
  }
}

function validateQuiz(meta) {
  const quiz = meta.quiz || meta
  if ((!quiz || quiz.question[quiz.question.lang] === '' || !quiz.answers || !quiz.answers.length === 0) && quiz.type !== 'sortable') {
    return `The quiz ${quiz.question[quiz.question.lang]} needs at least a question and a answer with text.\n`
  }

  if (quiz.answers && quiz.answers.length > 0) {
    let correctAnswer = false
    let hasText = false
    quiz.answers.map((answer) => {
      if (answer.correct) {
        correctAnswer = answer.correct
      }
      if (answer.text && answer.text[answer.text.lang] !== '') {
        hasText = true
      }
    })
    if ((!correctAnswer || !hasText) && quiz.type !== 'sortable') {
      return `The quiz ${quiz.question[quiz.question.lang]} needs at least a answer with text and a correct answer.\n`
    }
  }
  return ''
}

function validateSingleChoice(meta) {
  if (!meta.singleChoice || meta.singleChoice.question[meta.singleChoice.question.lang] === '' || !meta.singleChoice.options || !meta.singleChoice.options.length === 0) {
    return 'The single choice needs at least a question and a option.'
  }
  
  if (meta.singleChoice.options && meta.singleChoice.options.length > 0) {
    let hasText = false
    meta.singleChoice.options.map((option) => {
      if (option.text && option.text[option.text.lang] !== '') {
        hasText = true
      }
    })
    if (!hasText) {
      return 'The single choice needs at least a option with text.'
    }
  }

  return ''
}

function validateCover(meta) {
  if (!meta.URL || meta.URL[meta.URL.lang] === '') {
    return `The Iframe tag needs at least a url.`
  } else if (!validateUrl(meta.URL[meta.URL.lang])) {
    return 'The url is not valid.'
  }



  return ''
}

function validateOpenBehaviour(behaviour) {
  if (!behaviour.value || behaviour.value[behaviour.value.lang] === '' || behaviour.target === '') {
    return `The behaviour "open Url" needs at least a url and "DO OPEN IN" needs to be selected.`
  } else if (!validateUrl(behaviour.value[behaviour.value.lang])) {
    return 'The url is not valid.'
  }
  return ''
}

function validateOpenAssetBehaviour(behaviour) {
  if (!behaviour.value) {
    return `The behaviour "branching" needs at least a selected video asset.`
  }
  return ''
}

function validateUrl(value) {
  return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(value);
}